import type { $Fetch } from 'ofetch';
import type { AmbientacaoGateway } from '@/application/port/out/AmbientacaoGateway';
import type { Ambientacao, UpsertAmbientacaoCommand } from '@/domain/model/Ambientacao';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

/** Gateway HTTP de Ambientação — BE `/api/v1/ambientacoes` (JSON). */
export class HttpAmbientacaoGateway implements AmbientacaoGateway {
  private readonly path = '/api/v1/ambientacoes';
  constructor(private readonly client: $Fetch) {}

  async list(): Promise<Ambientacao[]> {
    const res = await this.client<ApiResponse<Ambientacao[]>>(this.path, { method: 'GET' });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertAmbientacaoCommand): Promise<Ambientacao> {
    const res = await this.client<ApiResponse<Ambientacao>>(this.path, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertAmbientacaoCommand): Promise<Ambientacao> {
    const res = await this.client<ApiResponse<Ambientacao>>(`${this.path}/${encodeURIComponent(id)}`, {
      method: 'PUT',
      body: cmd,
    });
    assertApiSuccess(res);
    return res.data;
  }

  async arquivar(id: string): Promise<void> {
    await this.client<void>(`${this.path}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
